import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip"
import { Archive } from "lucide-react"
import { ReactNode } from "react";

type Props = {
    title: string | ReactNode
    description?: string | undefined | null;
    isArchived?: boolean | undefined;
    archivedIconDescription?: string | undefined;
}

export const PageTitle = ({
    title,
    description = "",
    isArchived = false,
    archivedIconDescription = "",
  }: Props) => {
    return (
        <div className="flex items-center gap-4">
            <div>
                <p className="text-xs">{title}</p>

                <div className="flex items-center gap-1">
                    {(isArchived) && (
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Archive size={16} className="text-orange-600" />
                                </TooltipTrigger>
                                <TooltipContent>
                                    {archivedIconDescription}
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    )}

                    { description && (
                        <p className="text-sm font-semibold line-clamp-1">{description}</p>
                    )}
                </div>
            </div>
    </div>
    )
}
